import React from 'react';
import { handleActions } from 'redux-actions';
import * as ActionTypes from '../../../constants/ActionTypes';
import { merge, set as setPath } from 'lodash';
import { themeSystemDefault } from '../../../constants/SystemDefaults';

export const linksDataReducer = handleActions(
    {
        //TODO: temporary partial implementation of global reducer
        [ActionTypes.THEME_MODIFY_KEY]: (state, action) => {
            let pathCheck = action.path.split('.');
            if (pathCheck[0] === 'link') {
                pathCheck.shift();
                return merge({}, { ...state }, setPath({}, pathCheck, action.value));
            }

            return state;
        },
        [ActionTypes.LOGIN_SET_THEME]: (state, action) => {
            if (action.theme.hasOwnProperty('link')) {
                return { ...state, ...action.theme.link };
            }

            return state;
        }
    },
    themeSystemDefault.link
);

export default linksDataReducer;



// WEBPACK FOOTER //
// ./src/reducers/theme/data/links.js